import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import SuccessModal from "../SuccessModal";
import { canceledOrder } from "../../services/CancelOrder/canceledOrder";
import { removeGarment } from "../../services/OrdersAPI/Orders";
import { DeleteChallan } from "../../services/ChallanApi/Challan";

export default function ChallanDeleteModal({
  deleteChallanModal,
  setDeleteChallanModal,
  sendDataToChallanListData,
   challanId
}) {
  const navigate = useNavigate();
 
  const handleConfirmDeleteOrder = () => {
       
    DeleteChallan(challanId)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            if (Res) {
              const message = Res.message;
              const status = Res.status;
              if (status === true) {
                setModalVisible(true);
                setModalStatus("success");
                setModalText(message);
              } else {
                setModalVisible(true);
                setModalStatus("not Success");
                setModalText(message);
              }
              sendDataToChallanListData({
                info: true,
              });
            
              setDeleteChallanModal(false);
            }
          }
        })
        .catch((err) => {
          console.error("Delete Error:", err);
        });
  };

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const handleModalClose = () => {
    setDeleteChallanModal(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={deleteChallanModal}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!deleteChallanModal) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <i
                className="pi pi-cart-minus"
                style={{ fontSize: "50px", color: "#fff" }}
              ></i>
              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                Confirm Delete Challan
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>
             
            <div>
              <p className=" w-full text-2xl  font-semibold flex justify-content-center">Please Confirm You Want Delete Challan </p>
            </div>

            <div className="flex">

            <Button
              onClick={handleConfirmDeleteOrder}
              className="mt-1 mb-3 mx-4 border-round-xl flex1 "
            >
              <p className=" w-full text-2xl  font-semibold flex justify-content-center">
                YES
              </p>
            </Button>
            <Button
              onClick={() => handleModalClose()}
              className="mt-1 mb-3 mx-4 border-round-xl flex1"
            >
              <p className=" w-full text-2xl  font-semibold flex justify-content-center">
                No
              </p>
            </Button>
            </div>
          </div>
        )}
      ></Dialog>
      <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
}
